export const PresetColors = ['blue', 'purple', 'cyan', 'green', 'magenta', 'pink', 'red', 'orange', 'yellow', 'volcano', 'geekblue', 'lime', 'gold', 'white',
// Dui
'grey',
// Dui
'darkgreen',
// Dui
'teal' // Dui
];